export const COMMENTS_ORDER_BY = "localState:commentsOrderBy";

export const VIEWER_STATUS_CONTAINER_ID = "viewer-status";

export const POST_COMMENT_FORM_ID = "post-comment-form";
